import { defineMessages } from 'react-intl';

export default defineMessages({
  'link' : {
    'id' : 'shortcut_type.link.title',
    'defaultMessage' : 'Link'
  },
  'custom' : {
    'id' : 'shortcut_type.custom.title',
    'defaultMessage' : 'Custom'
  }
});
